var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 84,
    viewBox: "0 0 43 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 84,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    transform: "translate(-1373 -774)",
    fill: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1069,
    y: -72,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -386,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.713 40.0345L50.0343 40.593V83.9062L35.3362 68.2113V43.242L39.6051 45.3267L44.713 40.0345ZM21.2872 40.0345L15.9632 40.593V83.9062L30.6611 68.2113V43.242L26.3924 45.3267L21.2872 40.0345ZM61.5951 12.8986L63.317 18.8925L58.1479 22.3777L57.715 28.6052L51.6658 30.1111L49.1338 35.8097L42.9323 35.1546L38.6022 39.6281L33.0001 36.8913L27.3981 39.6281L23.068 35.1398L16.8665 35.7949L14.3345 30.0966L8.28529 28.6052L7.8524 22.3863L2.6685 18.8895L4.39068 12.8958L0.73584 7.84641L4.4024 2.80265L2.6685 -3.1793L7.84068 -6.66445L8.27357 -12.8836L14.3345 -14.3747L16.8665 -20.073L23.068 -19.4182L27.3981 -23.9062L33.0001 -21.1695L38.6022 -23.9062L42.9323 -19.4182L49.1338 -20.073L51.6658 -14.3747L57.715 -12.8688L58.1479 -6.64992L63.317 -3.16476L61.5951 2.82914L65.2644 7.84641L61.5951 12.8986ZM50.0605 7.84641C50.0605 4.49763 49.0675 1.22405 47.207 -1.56035C45.3465 -4.34476 42.7022 -6.51494 39.6083 -7.79646C36.5144 -9.07798 33.11 -9.41329 29.8256 -8.75997C26.5412 -8.10666 23.5242 -6.49407 21.1563 -4.12613C18.7883 -1.75818 17.1757 1.25876 16.5224 4.54319C15.8691 7.82762 16.2044 11.232 17.4859 14.3259C18.7675 17.4198 20.9376 20.0641 23.722 21.9246C26.5065 23.7851 29.78 24.7781 33.1288 24.7781C37.6172 24.7711 41.9198 22.985 45.0936 19.8112C48.2674 16.6374 50.0535 12.3348 50.0605 7.84641ZM33.1288 -4.40742C30.7053 -4.40742 28.3362 -3.68877 26.3211 -2.34233C24.306 -0.995903 22.7354 0.917833 21.808 3.15687C20.8805 5.39591 20.6379 7.85969 21.1106 10.2366C21.5834 12.6136 22.7505 14.797 24.4641 16.5107C26.1778 18.2244 28.3612 19.3915 30.7381 19.8643C33.1151 20.3371 35.5788 20.0945 37.8179 19.1671C40.0569 18.2397 41.9707 16.6691 43.3172 14.6541C44.6637 12.639 45.3824 10.2699 45.3824 7.84641C45.3731 4.6002 44.0789 1.48974 41.7826 -0.804865C39.4864 -3.09947 36.375 -4.39153 33.1288 -4.39852V-4.40742Z",
    fill: "#2C74D6"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -385,
    y: 1,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#EAECF0",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    fill: "white",
    transform: "translate(-1373 -774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1069,
    y: -72,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -386,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default "data:image/svg+xml,%3csvg width='43' height='84' viewBox='0 0 43 84' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='43' height='84' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect width='1440' height='1038' transform='translate(-1373 -774)' fill='%23F9FAFC'/%3e %3cg clip-path='url(%23clip1_3916_412046)'%3e %3crect x='-1069' y='-72' width='1457' height='318' rx='8' fill='white'/%3e %3cg clip-path='url(%23clip2_3916_412046)'%3e %3crect x='-386' width='429' height='222' rx='8' fill='white'/%3e %3cg opacity='0.15'%3e %3cpath d='M44.713 40.0345L50.0343 40.593V83.9062L35.3362 68.2113V43.242L39.6051 45.3267L44.713 40.0345ZM21.2872 40.0345L15.9632 40.593V83.9062L30.6611 68.2113V43.242L26.3924 45.3267L21.2872 40.0345ZM61.5951 12.8986L63.317 18.8925L58.1479 22.3777L57.715 28.6052L51.6658 30.1111L49.1338 35.8097L42.9323 35.1546L38.6022 39.6281L33.0001 36.8913L27.3981 39.6281L23.068 35.1398L16.8665 35.7949L14.3345 30.0966L8.28529 28.6052L7.8524 22.3863L2.6685 18.8895L4.39068 12.8958L0.73584 7.84641L4.4024 2.80265L2.6685 -3.1793L7.84068 -6.66445L8.27357 -12.8836L14.3345 -14.3747L16.8665 -20.073L23.068 -19.4182L27.3981 -23.9062L33.0001 -21.1695L38.6022 -23.9062L42.9323 -19.4182L49.1338 -20.073L51.6658 -14.3747L57.715 -12.8688L58.1479 -6.64992L63.317 -3.16476L61.5951 2.82914L65.2644 7.84641L61.5951 12.8986ZM50.0605 7.84641C50.0605 4.49763 49.0675 1.22405 47.207 -1.56035C45.3465 -4.34476 42.7022 -6.51494 39.6083 -7.79646C36.5144 -9.07798 33.11 -9.41329 29.8256 -8.75997C26.5412 -8.10666 23.5242 -6.49407 21.1563 -4.12613C18.7883 -1.75818 17.1757 1.25876 16.5224 4.54319C15.8691 7.82762 16.2044 11.232 17.4859 14.3259C18.7675 17.4198 20.9376 20.0641 23.722 21.9246C26.5065 23.7851 29.78 24.7781 33.1288 24.7781C37.6172 24.7711 41.9198 22.985 45.0936 19.8112C48.2674 16.6374 50.0535 12.3348 50.0605 7.84641ZM33.1288 -4.40742C30.7053 -4.40742 28.3362 -3.68877 26.3211 -2.34233C24.306 -0.995903 22.7354 0.917833 21.808 3.15687C20.8805 5.39591 20.6379 7.85969 21.1106 10.2366C21.5834 12.6136 22.7505 14.797 24.4641 16.5107C26.1778 18.2244 28.3612 19.3915 30.7381 19.8643C33.1151 20.3371 35.5788 20.0945 37.8179 19.1671C40.0569 18.2397 41.9707 16.6691 43.3172 14.6541C44.6637 12.639 45.3824 10.2699 45.3824 7.84641C45.3731 4.6002 44.0789 1.48974 41.7826 -0.804865C39.4864 -3.09947 36.375 -4.39153 33.1288 -4.39852V-4.40742Z' fill='%232C74D6'/%3e %3c/g%3e %3c/g%3e %3crect x='-385' y='1' width='427' height='220' rx='7' stroke='%23EAECF0' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect width='1440' height='1038' fill='white' transform='translate(-1373 -774)'/%3e %3c/clipPath%3e %3cclipPath id='clip1_3916_412046'%3e %3crect x='-1069' y='-72' width='1457' height='318' rx='8' fill='white'/%3e %3c/clipPath%3e %3cclipPath id='clip2_3916_412046'%3e %3crect x='-386' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };